// extracted by mini-css-extract-plugin
export default {"card":"asttCard_card__l9NYh"};